<template>

  <div class="title-cameras-menu">
    <div class="title-cameras-menu-text text">
        Список камер
    </div>
  </div>
  <draggable class="camera-button" :list="cameras_list" @change="log">
    <button 
      class="text button"
      v-for="element in cameras_list"
      :key="element.camera_info[0].name"
    >
      <span
        @click="get_stream(element)" 
      >
        {{ element.camera_info[0].name }}
      </span>
      <div class="">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
      
    </button>
  </draggable>

</template>

<script>

  import { defineComponent } from 'vue'
  import { VueDraggableNext } from 'vue-draggable-next'

  export default defineComponent({

    name: 'CamerasListMenuComponent',

    components: {
      draggable: VueDraggableNext,
    },

    props: ['cameras_list', 'new_positions', 'stream_url'],

    data() {
      return {
        data: [],
      }
    },
    methods: {
      log(event) {
        for (let a in this.cameras_list) {
          this.data.push({
            'camera_code':this.cameras_list[a].camera_code,
            'new_pos': a
          })
        }
        this.new_positions(this.data)
        this.data = []
      },

    get_stream (value) {
      event.preventDefault();
      this.stream_url({
        value:value
      })
      window.scrollTo({
        top: 0,
      })
    },
  },
})
</script>

<style scoped>

  .title-cameras-menu-text {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    margin-top: 7px;
  }

  .title-cameras-menu{
    width: 265px;
    height: 30px;
    background: #383838;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
  }
  
  .camera-button {
    text-align: center;
    height: 312px;
    overflow: auto;
  }

  .button {
    font-size: 14px;
    width: 220px;
    border: none;
    min-height: 31px;
    max-height: 70px;
    cursor: pointer;
    margin-bottom: 10px;
    background: #848484;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
  }

  .dot {
    width: 4px;
    height: 4px;
    background: rgb(51, 51, 51);
    border-radius: 50%;
    margin-bottom: 2px;
  }

  .button:hover {
    background: #383838;
  }

</style>
